import TaskContentTypes from '../../../types/TaskContentTypes';

export default {
  [TaskContentTypes.ACW]: 'ACW',
  [TaskContentTypes.EMAIL]: 'email',
  [TaskContentTypes.STATUS]: 'status',
  [TaskContentTypes.CALL_RECORDING]: 'callRecording',
  [TaskContentTypes.CHAT_DRAFT_MESSAGE]: 'chatDraftMessage',
};
